<div>
  <div class="main-card">
    <div class="card-header">
      <a *ngIf="backPath" class="main-btn back-btn" [routerLink]="backPath"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <section class="flex align-items-center">
        <ng-content select="[buttons]"></ng-content>
        <app-button
          *ngIf="showSaveButton"
          type="button"
          btnStyle="main"
          icon="save"
          (click)="onSubmitForm()"
          >{{ saveBtnText | translate }}</app-button
        >
      </section>
    </div>
    <div class="card-body" [hidden]="!skeletonLoad">
      <div class="p-4">
        <app-skeleton></app-skeleton>
      </div>
    </div>
    <div class="card-body" [hidden]="skeletonLoad">
      <ng-container *ngTemplateOutlet="content"></ng-container>

      <!-- Wrap content in template -->
      <ng-template #content>
        <ng-content></ng-content>
      </ng-template>
    </div>
  </div>
</div>
